import { useEffect } from "react";

import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { PROVIDER_REGISTRATION_TITLE_PROPS } from "~/utils/providerRegistrationHelpers";

const Agreement = () => {
  const { control, register, trigger } = useFormContext();

  useEffect(() => {
    trigger("agreement");
  }, [trigger]);

  return (
    <Stack direction="column" spacing={4}>
      <Stack direction="column" spacing={2}>
        <Typography align="left" {...PROVIDER_REGISTRATION_TITLE_PROPS}>
          I agree to keep my information updated on the provider directory at least every 3 months. (This is a requirement for our
          directory. By checking &quot;I Agree&quot;, you agree to receive notifications reminding you to update your information.)
        </Typography>
        <Controller
          control={control}
          defaultValue={false}
          name="agreement"
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  {...register("agreement", { required: true })}
                  {...field}
                  checked={!!field.value}
                  onChange={(e) => {
                    field.onChange(!!e.target.checked);
                  }}
                />
              }
              label="I Agree"
              sx={{
                justifyContent: "center",
              }}
            />
          )}
        />
      </Stack>
    </Stack>
  );
};

export default Agreement;
